<script>
import { listQuickNav, getQuickNavMenuTree, saveQuickNav } from "@/api/wms/quickNav";

export default {
  name: "QuickNav",
  data() {
    return {
      // 快捷导航项（后端已按权限过滤并拼好完整路由 path）
      items: [],
      // 是否可配置（后端根据管理员身份返回）
      canEdit: false,
      // 顶栏弹出面板
      popoverVisible: false,
      // 配置弹窗
      dialogVisible: false,
      saving: false,
      menuTree: [],
      // 弹窗中已选列表：{menuId, name, icon(覆盖值，空为跟随菜单), menuIcon}
      checkedItems: [],
      defaultProps: {
        label: "label",
        children: "children",
        disabled: "disabled"
      },
      iconOptions: [
        { value: "", label: "跟随菜单图标" },
        { value: "el-icon-s-home", label: "首页" },
        { value: "el-icon-s-order", label: "订单" },
        { value: "el-icon-s-goods", label: "商品" },
        { value: "el-icon-box", label: "箱子" },
        { value: "el-icon-truck", label: "物流" },
        { value: "el-icon-ship", label: "海运" },
        { value: "el-icon-receiving", label: "收货" },
        { value: "el-icon-tickets", label: "单据" },
        { value: "el-icon-s-management", label: "管理" },
        { value: "el-icon-s-data", label: "数据" },
        { value: "el-icon-s-finance", label: "财务" },
        { value: "el-icon-money", label: "费用" },
        { value: "el-icon-s-check", label: "审核" },
        { value: "el-icon-s-claim", label: "申请" },
        { value: "el-icon-s-marketing", label: "营销" },
        { value: "el-icon-s-shop", label: "店铺" },
        { value: "el-icon-s-custom", label: "客户" },
        { value: "el-icon-s-operation", label: "操作" },
        { value: "el-icon-s-promotion", label: "推广" },
        { value: "el-icon-printer", label: "打印" },
        { value: "el-icon-document", label: "文档" },
        { value: "el-icon-folder", label: "目录" },
        { value: "el-icon-star-on", label: "星标" },
        { value: "el-icon-time", label: "时间" },
        { value: "el-icon-setting", label: "设置" },
        { value: "el-icon-location-outline", label: "库位" },
        { value: "el-icon-guide", label: "引导" },
        { value: "el-icon-s-tools", label: "工具" },
        { value: "el-icon-menu", label: "菜单" }
      ]
    };
  },
  methods: {
    // 拉取当前用户可见的快捷导航
    fetchQuickNav() {
      listQuickNav().then(res => {
        this.items = res.data || [];
        this.canEdit = !!res.canEdit;
      }).catch(() => {
        // 加载失败时整块隐藏，不影响其他功能
        this.items = [];
      });
    },
    // 点击快捷图标跳转并收起面板
    handleNavClick(item) {
      if (!item.path) return;
      this.popoverVisible = false;
      this.$router.push(item.path);
    },
    // 打开配置弹窗
    openConfig() {
      this.popoverVisible = false;
      getQuickNavMenuTree().then(res => {
        this.menuTree = res.data || [];
        this.checkedItems = this.items.map(it => ({
          menuId: it.menuId,
          name: it.menuName,
          icon: it.icon && it.icon !== it.menuIcon ? it.icon : "",
          menuIcon: it.menuIcon || ""
        }));
        this.dialogVisible = true;
        this.$nextTick(() => {
          if (this.$refs.menuTree) {
            this.$refs.menuTree.setCheckedKeys(this.checkedItems.map(it => it.menuId));
          }
        });
      });
    },
    // 树勾选变化：同步右侧已选列表（保留已有顺序与图标配置，新勾选的追加到末尾）
    handleTreeCheck() {
      const nodes = this.$refs.menuTree.getCheckedNodes().filter(n => n.menuType === "C");
      const next = [];
      this.checkedItems.forEach(it => {
        if (nodes.some(n => n.id === it.menuId)) {
          next.push(it);
        }
      });
      nodes.forEach(n => {
        if (!next.some(it => it.menuId === n.id)) {
          next.push({ menuId: n.id, name: n.label, icon: "", menuIcon: n.icon || "" });
        }
      });
      this.checkedItems = next;
    },
    moveUp(index) {
      if (index <= 0) return;
      const list = this.checkedItems;
      list.splice(index - 1, 0, list.splice(index, 1)[0]);
    },
    moveDown(index) {
      const list = this.checkedItems;
      if (index >= list.length - 1) return;
      list.splice(index + 1, 0, list.splice(index, 1)[0]);
    },
    removeItem(index) {
      const removed = this.checkedItems.splice(index, 1)[0];
      if (removed && this.$refs.menuTree) {
        this.$refs.menuTree.setChecked(removed.menuId, false, false);
      }
    },
    // 保存配置（整体替换）
    submitConfig() {
      const payload = this.checkedItems.map((it, idx) => ({
        menuId: it.menuId,
        icon: it.icon || null,
        orderNum: idx
      }));
      this.saving = true;
      saveQuickNav(payload).then(() => {
        this.$message.success("快捷导航保存成功");
        this.dialogVisible = false;
        this.fetchQuickNav();
      }).catch(() => {}).finally(() => {
        this.saving = false;
      });
    }
  },
  created() {
    this.fetchQuickNav();
  }
};
</script>

<template>
  <el-popover
    v-if="canEdit || items.length > 0"
    v-model="popoverVisible"
    placement="bottom-end"
    width="430"
    trigger="click">
    <!-- 快捷面板 -->
    <div class="quick-nav-panel">
      <div class="panel-header">
        <span class="panel-title">快速导航</span>
        <el-button
          v-if="canEdit"
          type="text"
          icon="el-icon-setting"
          class="config-btn"
          @click="openConfig">配置</el-button>
      </div>
      <div class="panel-grid">
        <div
          class="panel-item"
          v-for="item in items"
          :key="item.navId"
          :title="item.menuName"
          @click="handleNavClick(item)">
          <i :class="item.icon || 'el-icon-menu'"></i>
          <span>{{ item.menuName }}</span>
        </div>
      </div>
      <div v-if="!items.length" class="panel-empty">
        暂无快捷入口<span v-if="canEdit">，点击右上角"配置"添加常用功能</span>
      </div>
    </div>

    <!-- 顶栏触发图标 -->
    <div slot="reference" class="quick-nav-trigger" title="快速导航">
      <i class="el-icon-s-grid"></i>
    </div>

    <!-- 配置弹窗 -->
    <el-dialog title="配置快速导航" :visible.sync="dialogVisible" width="900px" append-to-body>
      <div class="config-wrapper">
        <div class="config-left">
          <p class="config-tip">勾选要加入快速导航的菜单（仅菜单项生效，目录用于分组展开）</p>
          <div class="tree-box">
            <el-tree
              ref="menuTree"
              :data="menuTree"
              show-checkbox
              check-strictly
              node-key="id"
              :props="defaultProps"
              :expand-on-click-node="false"
              empty-text="加载中，请稍候"
              @check="handleTreeCheck">
            </el-tree>
          </div>
        </div>
        <div class="config-right">
          <p class="config-tip">已选 {{ checkedItems.length }} 项，可调整顺序与图标</p>
          <div class="selected-box">
            <div class="selected-item" v-for="(item, index) in checkedItems" :key="item.menuId">
              <span class="item-index">{{ index + 1 }}</span>
              <i class="item-icon" :class="item.icon || item.menuIcon || 'el-icon-menu'"></i>
              <span class="item-name" :title="item.name">{{ item.name }}</span>
              <el-select v-model="item.icon" size="mini" class="item-icon-select" placeholder="图标">
                <el-option
                  v-for="opt in iconOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value">
                  <i v-if="opt.value" :class="opt.value" style="margin-right: 6px;"></i>
                  <span>{{ opt.label }}</span>
                </el-option>
              </el-select>
              <span class="item-ops">
                <el-button type="text" size="mini" icon="el-icon-top" :disabled="index === 0" @click="moveUp(index)"></el-button>
                <el-button type="text" size="mini" icon="el-icon-bottom" :disabled="index === checkedItems.length - 1" @click="moveDown(index)"></el-button>
                <el-button type="text" size="mini" icon="el-icon-delete" class="delete-btn" @click="removeItem(index)"></el-button>
              </span>
            </div>
            <div v-if="!checkedItems.length" class="selected-empty">请在左侧勾选菜单</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" class="button-search" :loading="saving" @click="submitConfig">确 定</el-button>
      </div>
    </el-dialog>
  </el-popover>
</template>

<style scoped>
/* 顶栏触发图标 */
.quick-nav-trigger {
  cursor: pointer;
}

.quick-nav-trigger i {
  font-size: 18px;
  vertical-align: middle;
}

/* 弹出面板 */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.panel-title {
  font-size: 15px;
  font-weight: bold;
  color: var(--theme-primary);
}

.config-btn {
  color: var(--theme-primary);
  padding: 0;
}

.config-btn:hover {
  filter: brightness(1.2);
}

.panel-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  max-height: 330px;
  overflow: auto;
}

.panel-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 4px 8px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: #ffffff;
}

.panel-item:hover {
  border-color: var(--theme-primary);
  background-color: color-mix(in srgb, var(--theme-primary) 8%, white 92%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.panel-item i {
  font-size: 22px;
  color: var(--theme-primary);
}

.panel-item span {
  margin-top: 6px;
  font-size: 12px;
  color: #333333;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.panel-empty {
  padding: 20px 0;
  text-align: center;
  font-size: 13px;
  color: #909399;
}

/* 配置弹窗 */
.config-wrapper {
  display: flex;
  gap: 16px;
}

.config-left {
  flex: 1;
  min-width: 0;
}

.config-right {
  flex: 1.3;
  min-width: 0;
}

.config-tip {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}

.tree-box {
  height: 400px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px;
}

.selected-box {
  height: 400px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 4px 8px;
}

.selected-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 2px;
  border-bottom: 1px dashed #eeeeee;
}

.item-index {
  width: 20px;
  font-size: 12px;
  color: #909399;
  text-align: center;
  flex-shrink: 0;
}

.item-icon {
  font-size: 18px;
  color: var(--theme-primary);
  flex-shrink: 0;
}

.item-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-icon-select {
  width: 130px;
  flex-shrink: 0;
}

.item-ops {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.item-ops .el-button {
  padding: 2px;
  margin-left: 4px;
}

.delete-btn {
  color: #f56c6c;
}

.selected-empty {
  padding: 30px 0;
  text-align: center;
  font-size: 13px;
  color: #909399;
}

.button-search {
  background-color: var(--theme-primary) !important;
  border-color: var(--theme-primary) !important;
  color: #ffffff;
}

.button-search:hover {
  filter: brightness(1.2);
}
</style>
